// MB-I18N-2A — common EN (extrait de LanguageContext, valeurs inchangées).
export default {
  "common.loading": "Loading...",
  "common.error": "Error",
  "common.success": "Success",
  "common.cancel": "Cancel",
  "common.confirm": "Confirm",
  "common.save": "Save",
  "common.delete": "Delete",
  "common.edit": "Edit",
  "common.back": "Back",
  "common.notifications": "Notifications",
  "common.no_notifications": "No notifications",
  "common.client": "Customer",
  "common.required": "Required",
  "common.optional": "Optional",
};
